import React, { useMemo, useCallback } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DataTable, { Column } from "../table/DataTable";
import { Box } from "@mui/material";

export interface Template {
  id: string;
  template: string;
  config_cd: string;
  config_url: string;
  config_desc: string;
  zone: string;
  services: string[];
}

interface TemplatesListProps {
  templates: Template[];
  loading?: boolean;
}

const TemplateList: React.FC<TemplatesListProps> = ({
  templates,
  loading = false,
}) => {
  const navigate = useNavigate();

  const handleView = useCallback(
    (id: string) => {
      navigate(`/templates/view/${id}`);
    },
    [navigate]
  );

  const columns: Column<Template>[] = useMemo(
    () => [
      {
        header: "Template Name",
        key: "config_cd",
      },
      {
        header: "Zone",
        key: "zone",
      },
      {
        header: "Actions",
        key: "id",
        render: (_: any, row: Template) => (
          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
          >
            <Button onClick={() => handleView(row.id)}>View</Button>
          </Box>
        ),
      },
    ],
    [handleView]
  );

  if (!Array.isArray(templates)) {
    console.error(
      "Expected templates to be an array, but received:",
      templates
    );
    templates = [];
  }

  return (
    <DataTable columns={columns} data={templates} loading={loading} />
  )
  
};

export default TemplateList;
